import jQuery from "jquery";

import { TABS_CHANGE_EVENT } from "../../../assets/scripts/ui/tabs.js";

const $ = jQuery;

const coreFAQSection = (function() {

  const me = {};

  const toggleMobileTabs = () => {

    const $tabs = $('.faq-section .tabs-title a');
    const openClassName = 'is-open';

    $tabs.on('click', (e) => {

      const $parentTab = $(e.target).closest('.tabs');

      if ($parentTab.hasClass(openClassName)) {
        $parentTab.removeClass(openClassName);
      } else {
        $parentTab.addClass(openClassName);
      }
    });
  };

  const toggleAidaDialog = () => {
    const aidaIframe = $('.aida-iframe');

    if (aidaIframe.is(':visible')) {
      document.querySelectorAll('.aida-iframe')[0].contentWindow.onbeforeunload = function () {
        return '';
      };
    } else {
      document.querySelectorAll('.aida-iframe')[0].contentWindow.onbeforeunload = function () {
        return undefined;
      };
    }
  };

  me.init = () => {

    toggleMobileTabs();

    // Checks if aida exists or not.
    if ($('.aida-iframe').length > 0) {

      // iframe loaded.
      $('.aida-iframe').on('load', () => {
        setTimeout(() => {
          toggleAidaDialog();
        }, 1000);
      });

      document.addEventListener(TABS_CHANGE_EVENT, () => {
        toggleAidaDialog();
      });
    }
  };

  return me;

}());

export default coreFAQSection;
